import { render, staticRenderFns } from "./Squad.vue?vue&type=template&id=65d3bec8&"
import script from "./Squad.vue?vue&type=script&lang=js&"
export * from "./Squad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports